module.exports = __webpack_public_path__ + "img/logo-back.339f8630.svg";